/**
 * --------------------------------------------------------------------------
 * CueSync index.umd.js
 * Licensed under MIT (https://github.com/cuesync/cuesync.github.io/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

import CueSync from './src/cuesync.js'

export default { CueSync }
